import CryptoJS from 'crypto-js';

const config = {
  key: 'server_date_time',
  iv: 'client_date_time'
}
export default {

  //加密
  encrypt(word, keyStr = config.key, ivStr = config.iv) {
    let iv = CryptoJS.enc.Utf8.parse(ivStr);
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },

  //解密
  decrypt(word, keyStr = config.key, ivStr = config.iv) {
    let iv = CryptoJS.enc.Utf8.parse(ivStr);
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
}


// WEBPACK FOOTER //
// ./src/api/aes.min.js